// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Comp_wrapper__26xh2"};